module.exports = __webpack_public_path__ + "static/media/image4.50f1ff68.jpg";